import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import LineChart from './LineChart';
import FastForwardIcon from '@material-ui/icons/FastForward';
import HBA1c from './HBA1C';
import Glucose from './Glucose';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }} className="pb-5px">
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function InsulineTabs(props) {
  const { dashboardLineChart, onTabChange } = props;
  const [value, setValue] = React.useState(0);
  
  const handleChange = (event, newValue) => {
    console.log("handleChange", newValue);
    setValue(newValue);
    onTabChange(newValue); // Calling the parent callback function
  };

  return (
    <Box sx={{ width: '100%' }} className="insuline-chartSection">
      <Box sx className="insuline-tabs">
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="INSULIN" {...a11yProps(0)} />
          <Tab label="HBA1C" {...a11yProps(1)} />
          <Tab label="GLUCOSE" {...a11yProps(2)}  />
          {/* <Tab label="BMI" {...a11yProps(3)} className='pointer-none' />
          <Tab label="PULSE " {...a11yProps(4)} className='pointer-none' /> */}
         
        </Tabs>
       {/* <FastForwardIcon className='mb-10px'></FastForwardIcon> */}
      </Box>
      <CustomTabPanel value={value} index={0}>
      <LineChart dashboardLineChart={dashboardLineChart?dashboardLineChart:""}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <HBA1c dashboardLineChart={value && value == 1? dashboardLineChart?dashboardLineChart:"":""}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Glucose dashboardLineChart={value && value == 2? dashboardLineChart?dashboardLineChart:"":""}/>
      </CustomTabPanel>
    </Box>
  );
}

InsulineTabs.propTypes = {
  dashboardLineChart: PropTypes.array.isRequired,
  onTabChange: PropTypes.func.isRequired, // Adding PropTypes validation for the new prop
};